import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import InventoryCountPanel from '../../components/Audit/InventoryCountPanel';
import { getWarehouses } from '../../services/warehousesService';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';

export default function AuditInventoryCountPage() {
  const { warehouseId } = useParams();
  const navigate = useNavigate();
  const { kardexAuditModuleEnabled } = useModuleSettings();
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWarehouses({ active_only: true })
      .then((res) => {
        if (res.success) setWarehouses(res.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  if (!kardexAuditModuleEnabled) {
    return (
      <div className="p-6">
        <p className="text-gray-600">El módulo de auditoría no está habilitado.</p>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <nav className="text-sm text-gray-600 mb-3">
        <Link to="/audit/kardex" className="hover:text-teal-600">Auditoría</Link>
        <span className="mx-2">/</span>
        <span className="text-gray-800">Toma de inventario</span>
      </nav>

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Toma de inventario por almacén</h1>
        <p className="text-gray-600 mt-1 text-sm">
          Asigne productos, defina plazos y active campañas de conteo por bodega.
        </p>
        <Link to="/audit/rules" className="inline-flex mt-2 text-sm text-teal-700 hover:underline">
          Ver reglas de alertas de inventario →
        </Link>
      </div>

      <div className="mb-6 p-4 bg-white border rounded-lg">
        <label className="block text-sm font-medium text-gray-700 mb-2">Almacén</label>
        {loading ? (
          <p className="text-sm text-gray-500">Cargando almacenes…</p>
        ) : (
          <select
            className="w-full max-w-md border rounded px-3 py-2 text-sm"
            value={warehouseId || ''}
            onChange={(e) => {
              const id = e.target.value;
              if (id) navigate(`/audit/inventory-count/${id}`);
              else navigate('/audit/inventory-count');
            }}
          >
            <option value="">Seleccione un almacén…</option>
            {warehouses.map((w) => (
              <option key={w.id} value={w.id}>{w.name || w.code}</option>
            ))}
          </select>
        )}
      </div>

      {!warehouseId ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {warehouses.map((w) => (
            <Link
              key={w.id}
              to={`/audit/inventory-count/${w.id}`}
              className="p-4 bg-white border rounded-lg hover:border-teal-500 hover:shadow-sm transition"
            >
              <p className="font-medium text-gray-900">{w.name || w.code}</p>
              <p className="text-sm text-teal-700 mt-1">Configurar toma de inventario →</p>
            </Link>
          ))}
        </div>
      ) : (
        <InventoryCountPanel warehouseId={warehouseId} mode="audit" />
      )}
    </div>
  );
}
